<template>
  <div class="flex flex-col align-center self-center" :class="{'overflow-hidden':type==='post' || type ==='image'}">
    <loading v-if='loading' class="pbc-z-level-5">
      <div class="text-xl text-orange-800 font-semibold tracking-tight">{{loadingMessage}}</div>
    </loading>

    <text-post-editor v-if='type === "text"'
                      :parent-id="parentId"
                      :op-id="opId"
                      class='mx-2'
                      @save='createTextPost'
                      />

    <image-post-editor v-if='type === "image"'
                      :parent-id="parentId"
                      :op-id="opId"
                      @save='createImagePost'
                      class='mx-2 overflow-hidden'
                      />

    <post-editor v-if='type === "post" && gamedata.id'
                 class='h-full overflow-hidden'
                 :gamedata="gamedata"
                 :parent-id="parentId"
                 :op-id="opId"
                 @save='createPost'
                 @change-stash='$emit("change-stash", $event)'
                 @change-draft='$emit("change-draft", $event)'
                 :key='gamedata.id'
                 :initial-title='initialTitle'
                 :id='draftId'
                 />

    <pbc-message ref="message" />
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { getPostsForQuery, getPostsQuery, deletePostDraft, addLocalMeme } from '@/gql/Queries.js';
import Loading from '@ui/atoms/Loading.vue';
import gql from 'graphql-tag';
import PostEditor from './PostEditor.vue';
import TextPostEditor from './TextPostEditor.vue';
import ImagePostEditor from './ImagePostEditor.vue';
import PbcMessage from '@ui/molecules/PbcMessage.vue';

export default {
  props: {
    type: {
      type: String,
      default: 'post'
    },
    parentId: {
      type: String,
      required: true
    },
    gamedata: {
      type: Object,
      default() {
        return {};
      }
    },
    opId: {
      type: String,
      default: 'root'
    },
    initialTitle: {
      type: String,
      default: ''
    },
    draftId:{
      type:String,
      required:true
    }
  },
  methods: {
    onFail() {
      this.loading = false;
    },
    checkSession() {
      // TODO: re-enable
      return true;
    },
    async createPost({data:{title, gamedata},draft}) {
      if (!this.checkSession()) {
        return
      }
      try {
        this.loading = true;
        this.loadingMessage = "Creating Post...";
        const signedUrl = await this.$apollo.mutate({
          fetchPolicy:'no-cache',
          mutation:gql(`
            mutation signedUrl {
              getSignedGameUploadUrl {
                id,
                url
              }
            }
          `),
        })
        const {id, url} = signedUrl.data.getSignedGameUploadUrl;
        const game = id;
        await this.uploadFile(url, JSON.stringify(gamedata));

        const op = (this.opId !== '' && this.opId !== 'root') ? this.parentId : this.opId;
        const parent = this.parentId;

        const createPost = await this.$apollo.mutate({
          mutation:gql(`
          mutation createPost(
            $parent: String!,
            $op: String!,
            $title: String!,
            $game: String!)  {

            createPost(
              parent: $parent,
              op: $op,
              title: $title,
              game: $game
            ) {
              type
              op
              id
              title
              game
              body
              author {
                id
                username
              }
              created
              downvotes
              upvotes
              clips {
                id
                postId
                status
                mp4Url
                gifUrl
                aspect
              }
              parent {
                id
                title
                author {
                  id
                  username
                }
              }
              metadata {
                cols
                rows
              }

            }

          }
          `),
          update: (store, { data: { createPost } }) => {
            //console.log('does it even call this one?');
            // NOTE: the size here MUST match the size in ApolloPosts
            const query = {
              query: getPostsQuery,
              variables: {
                type: 'new',
                from: 0,
                size: 10
              }
            }
            try {
              const data = store.readQuery(query);
              //console.log('data', data);
              //console.log('createPost', createPost);
              data.getPosts.items = [createPost, ...data.getPosts.items];
              store.writeQuery({
                ...query,
                data
              })
            } catch (e) {
              // ignore cache update errors on purpose
            }
            //this.updateStoreAfterVote(store, createVote, linkId)
          },
          variables: {
            parent,
            op,
            title,
            game
          },
        })
        .catch( (error) => {
          //console.log('catch the error over here');
          this.error = error;
        });

        this.loading = false;

        if (this.error) {
          console.error('error', this.error);
          this.$refs.message.show({
            title:'Whoops! Could not create post.',
            type: 'error',
            onClose: () => {
              this.onFail()
            }
          });
          return;
        }



        //console.log('created post', createPost);
        this.$refs.message.show({
          title:'Your post has been created.',
          onClose: () => {
            this.onDonePosting(createPost.data.createPost);
          }
        });
        this.postCreated = true;

      } catch (e) {
        this.loading = false;
        this.$refs.message.show({
          title:'Whoops! Could not create post.',
          onClose: () => {
            this.onFail()
          }
        });
        throw e;
      }

    },
    updateReplyToPost(key, store, { data }) {
      // NOTE: the size here MUST match the size in ApolloPosts
      const createdPostObject = data[key];
      //console.log('update called for text post', createdPostObject);
      const parentId = createdPostObject.parent.id;
      //console.log('the parent', parentId);
      const query = {
        query: getPostsForQuery,
        variables: {
          parent: parentId,
          from: 0,
          size: 10,
          type: "new"
        }
      }
      try {
        const data = store.readQuery(query);
        //console.log('data', data);
        //console.log('post', createdPostObject);
        //data.getPosts.items = [createdPostObject, ...data.getPosts.items];
        data.getPostsFor.items = [createdPostObject, ...data.getPostsFor.items];
        //console.log('new items', data.getPostsFor.items);
        store.writeQuery({
          ...query,
          data
        })
      } catch (e) {
        console.error('error', e);
        // ignore cache update errors on purpose
      }
      //this.updateStoreAfterVote(store, createVote, linkId)
    },
    async createImagePost({parentId,opId,image,title}) {
      try {
        this.loading = true;
        this.loadingMessage = "Creating Post...";

        const createImagePost = await this.$apollo.mutate({
          mutation:gql(`
          mutation createImagePost(
            $parent: String!,
            $op: String!,
            $image: String!,
            $aspect: String!,
            $title: String!
            ) {
            createImagePost(
              parent: $parent,
              op: $op,
              image: $image,
              aspect: $aspect,
              title: $title
            ) {
              op
              id
              title
              game
              body
              author {
                id
                username
              }
              created
              downvotes
              upvotes
              clips {
                id
                postId
                status
                mp4Url
                gifUrl
                aspect
              }
              parent {
                id
                title
                author {
                  id
                  username
                }
              }
              type
              image
              replies {
                total
              }
              topReplies {
                id
                game
                title
                type
                body
                image
                clips {
                  aspect
                  status
                  mp4Url
                }
                author {
                  id
                  username
                }
              }
              metadata {
                cols
                rows
              }

            }

          }
          `),
          update: this.updateReplyToPost.bind(this, 'createImagePost'),
          variables: {
            parent: parentId,
            op: opId,
            image,
            aspect: 'unknown',
            title
          }
        })
        .catch( (error) => {
          console.log('catch the error over here');
          this.error = error;
        });    

        this.loading = false;

        if (this.error) {
          console.error('error', this.error);
          this.$refs.message.show({
            title:'Whoops! Could not create post.',
            type: 'error',
            onClose: () => {
              this.onFail();
            }
          });
          return;
        }

        this.$refs.message.show({
          title:'Your post has been created.',
          onClose: () => {
            this.onDonePosting(createImagePost.data.createImagePost);
          }
        });
        this.postCreated = true;

      } catch (e) {
        this.loading = false;
        this.$refs.message.show({
          title:'Whoops! Could not create post.',
          onClose: () => {
            this.onFail();
          }
        });
        throw e;

      }
    },
    async createTextPost({parentId,opId,body}) {

      try {
        this.loading = true;
        this.loadingMessage = "Creating Post...";

        const createTextPost = await this.$apollo.mutate({
          mutation:gql(`
          mutation createTextPost(
            $parent: String!,
            $op: String!,
            $body: String!) {
            createTextPost(
              parent: $parent,
              op: $op,
              body: $body
            ) {
              op
              id
              title
              game
              body
              author {
                id
                username
              }
              created
              downvotes
              upvotes
              clips {
                id
                postId
                status
                mp4Url
                gifUrl
                aspect
              }
              parent {
                id
                title
                author {
                  id
                  username
                }
              }
              type
              image
              replies {
                total
              }
              topReplies {
                id
                game
                title
                type
                body
                image
                clips {
                  aspect
                  status
                  mp4Url
                }
                author {
                  id
                  username
                }
              }
              metadata {
                cols
                rows
              }

            }

          }
          `),
          update: this.updateReplyToPost.bind(this, 'createTextPost'),
          variables: {
            parent: parentId,
            op: opId,
            body
          }
        })
        .catch( (error) => {
          console.log('catch the error over here');
          this.error = error;
        });    

        this.loading = false;

        if (this.error) {
          console.error('error', this.error);
          this.$refs.message.show({
            title:'Whoops! Could not create post.',
            type: 'error',
            onClose: () => {
              this.onFail();
            }
          });
          return;
        }

        //console.log('successfull text post');
        this.$refs.message.show({
          title:'Your post has been created.',
          onClose: () => {
            this.onDonePosting(createTextPost.data.createTextPost);
          }
        });
        this.postCreated = true;

      } catch (e) {
        this.loading = false;
        this.$refs.message.show({
          title:'Whoops! Could not create post.',
          onClose: () => {
            this.onFail()
          }
        });
        throw e;

      }

    },
    async uploadFile(signedUrl, file) {
      this.loading = true;
      const options = {
        method: 'PUT',
        headers: {
          'Content-Type':'application/json'
        },
        body: file
      };
      const response = await fetch(signedUrl, options)
      if (!response.ok) {
        throw new Error(`${response.status}: ${response.statusText}`);
      }
    },
    async onDonePosting(post) {
      await this.$apollo.mutate({
        mutation:deletePostDraft,
        client:'localClient',
        variables:{
          id: this.id
        }
      });

      if (!this.$store.state.loggedIn) {
        await this.$apollo.mutate({
          mutation:addLocalMeme,
          client:'localClient',
          variables:cloneDeep(post)
        });
      }

      this.$emit("done", {post});
    },
  },
  data() {
    return {
      loading:false,
      loadingMessage:"Loading Post...",
      postCreated: false,
      promptUserLogin: false,
      deletePostDraft,
      loginState:{},
    }

  },
  components: {
    PostEditor,
    TextPostEditor,
    ImagePostEditor,
    PbcMessage,
    Loading,
  },
  watch: {
    '$apollo.loading'(nv) {
      this.loading = nv;
    }
  },
  computed: {
  }
}
</script>
